module.exports = __webpack_public_path__ + "static/media/section-afiliados.20dfb357.webp";